import type { Currency, Num } from "../types";

const grouped = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

/** "310,300 MXN". Nunca usa "$": al pegar en Google Docs se vuelve fórmula. */
export function fmtMoney(v: Num, currency: Currency = "MXN", decimals = 0): string {
  if (v === null || !Number.isFinite(v)) return "—";
  const f = decimals === 0 ? grouped : new Intl.NumberFormat("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  return `${f.format(v)} ${currency}`;
}

/** 0.3825 → "38.25%" */
export function fmtPct(v: Num, decimals = 2): string {
  if (v === null || !Number.isFinite(v)) return "—";
  return `${(v * 100).toFixed(decimals)}%`;
}

/** 0.3469 → "34.7 pts" */
export function fmtPts(v: Num, decimals = 1): string {
  if (v === null || !Number.isFinite(v)) return "—";
  const n = v * 100;
  return `${n > 0 ? "+" : ""}${n.toFixed(decimals)} pts`;
}

export function fmtNum(v: Num, decimals = 0): string {
  if (v === null || !Number.isFinite(v)) return "—";
  return new Intl.NumberFormat("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(v);
}

export function fmtYears(v: number | "never" | null | undefined): string {
  if (v === null || v === undefined) return "—";
  if (v === "never") return "nunca a este ritmo";
  return `${v.toFixed(1)} años`;
}

/** 4.06 → "~4 meses"; 0.6 → "menos de un mes". */
export function fmtMeses(v: Num): string {
  if (v === null || !Number.isFinite(v)) return "—";
  if (v < 1) return "menos de un mes";
  const n = Math.round(v);
  return `~${n} ${n === 1 ? "mes" : "meses"}`;
}

/** Dinero compacto para textos cortos: 50,555,600 → "50.6 millones MXN"; 120,000 → "120,000 MXN". */
export function fmtMoneyCorto(v: Num, currency: Currency = "MXN"): string {
  if (v === null || !Number.isFinite(v)) return "—";
  if (Math.abs(v) >= 1e6) { const m = Math.round((v / 1e6) * 10) / 10; return `${m.toString()} ${Math.abs(m) === 1 ? "millón" : "millones"} ${currency}`; }
  return fmtMoney(v, currency);
}
